export const EXPIRATION_TYPE = {
  HARD: 'hard',
  SOFT: 'soft',
};

export const EXPIRATION_TYPE_OPTIONS = [
  { value: EXPIRATION_TYPE.HARD, label: 'Hard' },
  { value: EXPIRATION_TYPE.SOFT, label: 'Soft' },
];
